import { Hardness } from "components/Viewer3d/consts";

export const DEFAULT_HARDNESS = Hardness.Medium;

export interface GCodeSetting {
  id: number | null,
  side: string,
  designId: number,
  printerId: string,
  insoleHardness: Hardness | null,
  foreFootHardness: Hardness | null,
  midInnerHardness: Hardness | null,
  midOuterHardness: Hardness | null,
  heelHardness: Hardness | null,
  checkToRemove: boolean | null
}

export function cloneGCodeSetting(setting: GCodeSetting): GCodeSetting {
  return {
    ...setting
  };
}

// Applies defaults where it is needed (if the values are not already provided)
export function applyGCodeSettingDefaults(setting: GCodeSetting): GCodeSetting {
  if (
    !setting.insoleHardness &&
    !setting.foreFootHardness &&
    !setting.midInnerHardness &&
    !setting.midOuterHardness &&
    !setting.heelHardness
  ) {
    setting.insoleHardness = DEFAULT_HARDNESS;
  }

  return setting;
}

export function getDefaultGcodeSetting(side: string, designId: number) {
  const outResult: GCodeSetting = {
    id: null,
    side: side,
    designId: designId,
    printerId: '',
    insoleHardness: DEFAULT_HARDNESS,
    foreFootHardness: null,
    midInnerHardness: null,
    midOuterHardness: null,
    heelHardness: null,
    checkToRemove: null
  };
  return outResult;

}